import { useState } from "react";
import { Collapse, IconButton } from "@chakra-ui/react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { SidebarHeader } from "../SidebarHeader";
import { MdApps } from "react-icons/md";
import { Container, Content, ContentDetailFooter, Wrap, GridButton } from "./styles";
import SideMenu from "../SideMenu";
import useGetDropdown from "../../hooks/useGetDropdown";
import CreateEditModal from "../CreateEditModal";
import ImportModal from "../ImportModal";
import useGetSafraEUnidade from "../../hooks/useGetSafraEUnidade";
import DeleteModal from "../DeleteModal";
import useGetDropdownImport from "../../hooks/useGetDropdownImport";
import SelecaoTalhoesModal from "../SelecaoTalhoesModal";
import { Icon } from "../Icon";
import DeleteModalTable from "../DeleteModalTable";
import useMapData from "../../hooks/useMapData";
import { useFilters } from "core/features/filters/store";
import ModalPlanejamentoOperacoes from "../ModalPlanejamentoOperacoes";
import useComponenteDropdownList from "../../hooks/useComponenteDropdownList";
import useModal from "../../hooks/useModal";

interface FilterComponentProps {
  filters: any;
  setFilters: any;
  planoOperacionalData: any;
  dataMapOS: any;
  refetch: any;
  refetchMap: any;
}

export default function FilterComponent({
  filters,
  setFilters,
  planoOperacionalData,
  dataMapOS,
  refetch,
  refetchMap
}: FilterComponentProps) {

  const { filters: { tabBarSessaoPlanejamentoOperacional, menuName, menuNameRelatorios } } = useFilters();
  const { isOpenImport } = useModal();
  const [open, setOpen] = useState(true);
  const { data: safraEUnidade } = useGetSafraEUnidade(filters);

  const { data: dropdownData } = useGetDropdown();
  const { data: dropdownDataImport } = useGetDropdownImport(isOpenImport);
  const { setSidebarMenuOpen } = useMapData();
  const { data: dataComponente } = useComponenteDropdownList({ apenasInsumos: true });

  const handleOpenMenu = () => {
    setOpen(!open);
    setSidebarMenuOpen(!open);
  };

  const dados = {
    ...dropdownData,
    periodoSafraList: safraEUnidade,
  }

  const options = (
    tabBarSessaoPlanejamentoOperacional === 'cadastros'
    || (
      tabBarSessaoPlanejamentoOperacional === 'relatorios'
      && menuNameRelatorios === 'Relatório de Aderência Operacional'))
    || (menuName !== 'Gestão de Justificativa' && tabBarSessaoPlanejamentoOperacional !== 'agenda-campo' && tabBarSessaoPlanejamentoOperacional !== 'relatorios')

  return (
    <>
      <Container>
        <CreateEditModal filtersData={dados} refetch={refetch} />
        <ModalPlanejamentoOperacoes dataComponente={dataComponente} planoOperacionalData={planoOperacionalData} dados={{ ...dados, dataComponente }} />
        <DeleteModal refetch={refetch} refetchMap={refetchMap} />
        <DeleteModalTable />
        <ImportModal filtersData={dropdownDataImport} />
        <SelecaoTalhoesModal />
        <Wrap>
          <SidebarHeader
            filters={filters}
            setFilters={setFilters}
            planoOperacionalData={planoOperacionalData}
          />
          <IconButton
            aria-label="expand-filters"
            icon={<FaChevronDown color="#848484" width="6px" height="6px" />}
            position="absolute"
            right="20px"
            borderRadius="7px"
            borderTopLeftRadius="0"
            borderTopRightRadius="0"
            background="#ffffff"
            height={open ? "0px !important" : "28px"}
            overflow="hidden"
            _active={{}}
            _focus={{}}
            _hover={{
              height: "38px",
              bottom: "-30px",
            }}
            transition="all .5s"
            bottom={!open ? "-20px" : "0px !important"}
            alignItems="flex-end"
            paddingBottom="5px"
            onClick={handleOpenMenu}
            pointerEvents={open ? "none" : undefined}
          />
        </Wrap>

        {options && (
          <Collapse in={open} animateOpacity style={{ width: "100%" }}>
            <Content execucion={tabBarSessaoPlanejamentoOperacional !== 'cadastros'}>
              <SideMenu
                planoOperacionalData={planoOperacionalData}
                dataMapOS={dataMapOS}
              />
              <ContentDetailFooter>
                <GridButton>
                  <Icon icon={MdApps} />
                  Talhões em GRID
                </GridButton>
                <IconButton
                  aria-label="expand-filters"
                  icon={<FaChevronUp color="#848484" width="6px" height="6px" />}
                  position="relative"
                  right="20px"
                  borderRadius="7px"
                  borderTopLeftRadius="0"
                  borderTopRightRadius="0"
                  background="#ffffff"
                  height={"28px"}
                  overflow="hidden"
                  _active={{}}
                  _focus={{}}
                  _hover={{
                    backgroundColor: "transparent",
                  }}
                  transition="all .5s"
                  alignItems="flex-end"
                  paddingBottom="5px"
                  onClick={handleOpenMenu}
                  pointerEvents={undefined}
                />
              </ContentDetailFooter>
            </Content>
          </Collapse>
        )}
      </Container>
    </>
  );
}
